interface DrawerStatusBarProps {
  hasApiError: boolean;
  isLoading: boolean;
  onRefresh: () => void;
  expanded?: boolean;
}

export default function DrawerStatusBar({
  hasApiError,
  isLoading,
  onRefresh,
}: DrawerStatusBarProps) {
  // 확장된 뷰 - 새로고침 및 상태 표시
  return (
    <div className="flex items-center justify-between mb-6 p-4 bg-gray-50 rounded-lg">
      <div className="flex items-center space-x-3">
        {hasApiError && (
          <div className="flex items-center text-red-600">
            <i className="ri-error-warning-line mr-1"></i>
            <span className="text-sm">데이터 로드 오류</span>
          </div>
        )}
        {isLoading && (
          <div className="flex items-center text-blue-600">
            <i className="ri-loader-4-line animate-spin mr-1"></i>
            <span className="text-sm">업데이트 중...</span>
          </div>
        )}
        {!hasApiError && !isLoading && (
          <div className="flex items-center text-green-600">
            <i className="ri-check-circle-line mr-1"></i>
            <span className="text-sm">최신 데이터</span>
          </div>
        )}
      </div>
      <button
        onClick={onRefresh}
        disabled={isLoading}
        className={`flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
          isLoading
            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
            : 'bg-white hover:bg-gray-100 text-gray-700 border border-gray-200'
        }`}
      >
        <i
          className={`${isLoading ? 'ri-loader-4-line animate-spin' : 'ri-refresh-line'}`}
        ></i>
        <span>{isLoading ? '새로고침 중...' : '새로고침'}</span>
      </button>
    </div>
  );
}
